import { DataTable, type DataTableProps } from "@fawkes/ui";

import { useTabelIndeling } from "../hooks/useTabelIndeling";

/**
 * Een {@link DataTable} waarvan de gebruiker de kolommen mag verschuiven en breder maken, en die dat
 * onthoudt.
 *
 * <p>Waarom een wikkel en niet de hook in elk scherm: het gaat om tachtig tabellen verspreid over het
 * hele systeem. Drie losse regels per scherm (import, hook, twee props) is drie keer zoveel kans om er
 * eentje half te doen, en bij de volgende verbetering aan de indeling moeten ze allemaal weer open.
 * Zo is het per lijst één prop, en staat het gedrag op één plek.
 *
 * <p>Waarom niet in {@code @fawkes/ui} zelf: dat pakket is vormgeving en kent de server niet. Het
 * bewaren hoort aan deze kant, bij de hook die hem naar {@code tabel-indeling/{sleutel}} schrijft.
 *
 * @param tabelKey de vaste sleutel waaronder de indeling van déze lijst wordt bewaard. Hij staat in de
 *                 database naast de gebruikersnaam, dus hij moet uniek zijn over het hele systeem en
 *                 niet veranderen — anders is iemands indeling na een hernoeming spoorloos.
 */
export function IndeelbareTabel<T>({ tabelKey, ...rest }: DataTableProps<T> & { tabelKey: string }) {
  const { indeling, setIndeling } = useTabelIndeling(tabelKey);
  return <DataTable<T> {...rest} indeling={indeling} onIndelingChange={setIndeling} />;
}
